import React from 'react'
import {
	DistributionBar,
	HorizontalBars,
} from '../../reports/components/ReportVisuals'
import { ACTIVITY_ROWS, ASSIGNED_STUDENTS_COUNT, COVERAGE_SEGMENTS } from '../../data/settingsData'
import s from './WorkOverview.module.scss'

export const WorkOverview = () => (
	<section className={s.work}>
		<div className={s.work__head}>
			<div>
				<h2 className={s.work__title}>My work overview</h2>
			</div>
			<span className={s.work__meta}>{ASSIGNED_STUDENTS_COUNT} assigned students</span>
		</div>
		<div className={s.work__grid}>
			<article className={s.work__card}>
				<h3 className={s.work__cardTitle}>Student coverage</h3>
				<p className={s.work__cardText}>
					Students supported through sessions, assignments or applications.
				</p>
				<DistributionBar
					label="Student coverage"
					segments={COVERAGE_SEGMENTS}
				/>
			</article>
			<article className={s.work__card}>
				<h3 className={s.work__cardTitle}>My recorded work</h3>
				<p className={s.work__cardText}>Work recorded in the current counselling cycle.</p>
				<HorizontalBars
					rows={ACTIVITY_ROWS}
					max={90}
					ariaLabel="My recorded counselling work"
				/>
			</article>
		</div>
	</section>
)

export default WorkOverview
